import {Spinner, SpinnerSize} from '@gwc/core'
import clsx from 'clsx'

import {Grid} from '../grid'
import {classes} from './Loader.classes'

type Props = {
  className?: string
  fullscreenHeight?: boolean
  fullWidth?: boolean
  size?: SpinnerSize
}

export default function Loader({className, fullWidth, fullscreenHeight, size}: Props) {
  return (
    <Grid
      alignItems="center"
      className={clsx(classes.root, className, {
        [classes.fullscreenHeight]: fullscreenHeight,
        [classes.fullWidth]: fullWidth,
      })}
      justify="center"
      wrap="nowrap"
      container
    >
      <Grid item>
        <Spinner size={size} />
      </Grid>
    </Grid>
  )
}
